import "./styles.scss";

import { useState } from "react";
import { Formik, Form } from "formik";
import { useTranslation } from "react-i18next";

import { useWebmasters } from "context/admin/webmasters";

import ModalNew from "components/ModalNew";
import FormikInput from "components/formik/FormikInput";
import PasswordValidator from "components/PasswordValidator";

import createAccountSchema from "libs/validations/admin/createAccountSchema";

const mainClass = "create-account-modal";

const CreateAccountModal = ({ isOpen, onClose }) => {
  const { t } = useTranslation();

  const { createAccount } = useWebmasters();

  const [confirmation_email, setConfirmationEmail] = useState(null);

  const onSubmit = async (values, setSubmitting, setErrors, resetForm) => {
    try {
      await createAccount(values);

      setConfirmationEmail(values?.email);
      resetForm();
    } catch (err) {
      if (err?.response?.data?.type === "email_exist") {
        setErrors({ email: err?.response?.data?.error });
      }
    }

    setSubmitting(false);
  };

  const handleClose = () => {
    if (typeof onClose === "function") onClose();

    setConfirmationEmail(null);
  };

  return (
    <Formik
      initialValues={{
        first_name: "",
        last_name: "",
        email: "",
        password: "",
        password2: "",
      }}
      enableReinitialize
      validationSchema={createAccountSchema}
      onSubmit={(values, { setSubmitting, setErrors, resetForm }) => {
        onSubmit(values, setSubmitting, setErrors, resetForm);
      }}
    >
      {({ values, isSubmitting, submitForm }) => (
        <ModalNew
          className={
            !!!confirmation_email ? "modal-new--add-webmaster" : undefined
          }
          title={t(
            !!confirmation_email
              ? "The account has been created"
              : "Add new account",
          )}
          labelSubmit={t(!!confirmation_email ? "Close" : "Create")}
          loading={isSubmitting}
          isOpen={isOpen}
          isBackdropDisabled={!!!confirmation_email}
          onClose={handleClose}
          onSubmit={!!confirmation_email ? handleClose : submitForm}
        >
          <Form autoComplete="off">
            {!!confirmation_email ? (
              <div className={mainClass}>
                <p>
                  {t(
                    "The webmaster account has been created. It needs to be activated before you can start using it.",
                  )}
                </p>
                <p>
                  {t(
                    "The activation link will be sent to the following email address:",
                  )}{" "}
                  <strong>{confirmation_email}</strong>
                </p>
              </div>
            ) : (
              <div className={`${mainClass}__form form`}>
                <div className="column-layout">
                  <div className="column-layout__col">
                    <FormikInput
                      name="first_name"
                      label={t("Name")}
                      placeholder={t("John")}
                      disabled={isSubmitting}
                    />
                    <FormikInput
                      name="last_name"
                      label={t("Surname")}
                      placeholder={t("Doe")}
                      disabled={isSubmitting}
                    />
                    <FormikInput
                      name="email"
                      label={t("Email")}
                      type="email"
                      placeholder={t("j.doe@domain.com")}
                      disabled={isSubmitting}
                    />
                  </div>
                  <div className="column-layout__col column-layout__col--password">
                    <FormikInput
                      name="password"
                      type="password"
                      label={t("New password")}
                      placeholder="***************"
                    />
                    <FormikInput
                      name="password2"
                      type="password"
                      label={t("Repeat new password")}
                      placeholder="***************"
                    />
                    <PasswordValidator
                      password={values?.password}
                      variant="checkmarks"
                      hasProgress
                    />
                  </div>
                </div>
              </div>
            )}
          </Form>
        </ModalNew>
      )}
    </Formik>
  );
};

export default CreateAccountModal;
